var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prog-bar"},[_c('div',{class:_vm.classNames,style:({ width: _vm.percent + '%' })},[_vm._v(_vm._s(_vm.percent)+"%")])])}
var staticRenderFns = []

export { render, staticRenderFns }